import React from 'react';
export function IntegrationsSection() {
  return <section className="w-full bg-page-bg py-20 md:py-24 px-5" data-id="element-134">
      <div className="max-w-6xl mx-auto" data-id="element-135">
        {/* Section badge */}
        <div className="flex justify-center mb-4" data-id="element-136">
          <span className="inline-block border rounded-full px-4 py-1 text-xs uppercase font-bold tracking-widest" style={{
          borderColor: '#FF4081',
          color: '#FF4081'
        }} data-id="element-137">
            INTEGRAZIONI
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-navy text-center" data-id="element-138">
          Collega i tuoi check-in e{' '}
          <span style={{
          color: '#FF4081'
        }} data-id="element-139">
            inizia subito a risparmiare.
          </span>
        </h2>

        {/* Pink underline accent */}
        <div className="flex justify-center mt-4" data-id="element-140">
          <div style={{
          width: '40px',
          height: '3px',
          background: '#FF4081',
          borderRadius: '2px'
        }} data-id="element-141" />
        </div>

        {/* Subtext */}
        <p className="font-body text-body-gray text-base md:text-lg mt-4 max-w-2xl mx-auto text-center leading-relaxed" data-id="element-142">
          Bastano pochi secondi: collega Airbnb, Booking o il tuo channel
          manager e CleanAI sincronizza automaticamente ogni check-in e
          check-out. Da lì, l'algoritmo fa tutto il resto.
        </p>

        {/* Piattaforme group */}
        <div className="mt-12" data-id="element-143">
          <p className="font-heading font-semibold text-sm uppercase tracking-widest text-navy text-center mb-6" data-id="element-144">
            Piattaforme
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto" data-id="element-145">
            {/* Airbnb */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/45osBDDkw5i3k6hcKGSonU/Airbnb_Logo_Belo.svg.png" alt="Airbnb" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-147" />
            </div>

            {/* Booking.com */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/ijk4oeZxCmpT9Dz9oUV6v7/Booking.com_Logo.svg.png" alt="Booking.com" className="max-h-[28px] md:max-h-[36px] w-auto object-contain" data-id="element-149" />
            </div>

            {/* Expedia */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center col-span-2 md:col-span-1" data-id="element-150">
              <img src="https://cdn.magicpatterns.com/uploads/fdGE9gSnABfyVQRMznYuKj/Expedia-Horizontal-Logo-Product-Full-Colour-Dark-Blue-RGB.png" alt="Expedia" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-151" />
            </div>
          </div>
        </div>

        {/* Channel Manager group */}
        <div className="mt-10" data-id="element-152">
          <p className="font-heading font-semibold text-sm uppercase tracking-widest text-navy text-center mb-6" data-id="element-153">
            Channel Manager
          </p>
          <div className="grid grid-cols-2 gap-4 md:gap-6 max-w-xl mx-auto" data-id="element-154">
            {/* Smoobu */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-155">
              <img src="https://cdn.magicpatterns.com/uploads/w3GDjcR2RsaqPygBAaWFbb/68c1308e367bcd541b966254_Smoobu_logo_blue_h.svg" alt="Smoobu" className="max-h-[28px] md:max-h-[36px] w-auto object-contain" data-id="element-156" />
            </div>

            {/* Lodgify */}
            <div className="bg-white border-2 border-gray-100 rounded-none p-6 md:p-8 flex items-center justify-center" data-id="element-157">
              <img src="https://cdn.magicpatterns.com/uploads/2qJqt7c2yXUjyFsbXdDaZj/Lodgify-Integration.jpg" alt="Lodgify" className="max-h-[32px] md:max-h-[40px] w-auto object-contain" data-id="element-158" />
            </div>
          </div>
        </div>

        {/* Callout */}
        <div className="mt-10 max-w-3xl mx-auto text-center" data-id="element-159">
          <p className="font-body md:text-[15px] text-[16px]" style={{
          color: '#FF4081'
        }} data-id="element-160">
            Colleghi una volta, e CleanAI sa sempre quando arrivano i tuoi
            ospiti.
          </p>
        </div>
      </div>
    </section>;
}